import { DialogProps, Dialog as MuiDialog } from '@mui/material';

type TProps = DialogProps;

export function Dialog({ ...props }: TProps): React.JSX.Element {
  return <MuiDialog {...props} sx={{ '.MuiPaper-root': { borderRadius: 4 } }} />;
}
